var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.42873 10.1613C4.90883 10.0421 4.44137 9.75977 4.09743 9.35714L1.06213 5.79376C0.85741 5.55317 0.798069 5.22469 0.906157 4.93205C1.01443 4.63945 1.27382 4.42708 1.58667 4.37484C1.89966 4.32283 2.2184 4.43892 2.4231 4.67951L5.45875 8.24221C5.57595 8.3795 5.74504 8.46386 5.92635 8.47494C6.10764 8.4862 6.28509 8.42349 6.4165 8.30149L14.3374 0.951429C14.5084 0.792964 14.7369 0.708433 14.9727 0.716103C15.2086 0.723592 15.4325 0.822981 15.5951 0.992246C15.7579 1.16155 15.846 1.3866 15.8404 1.61826C15.8346 1.85006 15.7354 2.06903 15.5644 2.22752L7.64222 9.5768C7.0536 10.1242 6.22261 10.3436 5.42864 10.1611L5.42873 10.1613Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepIcon3);
export default __webpack_public_path__ + "static/media/Step_Icon_3.ea396ea6b29d148de23faf27ad9ce215.svg";
export { ForwardRef as ReactComponent };